import { LoadingOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, message, Row, Spin } from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import layer from "../../../Images/Layer_1.png";
import { AuthService } from "../../../../Services/AuthService";
import { MD5 } from "crypto-js";

interface IVendorCreatePasswordProps {
  token?: string;
  password: string;
  confirmPassword: string;
}
const VendorCreatePassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 14, color: "white" }} spin />
  );
  const [loading, setLoading] = React.useState(false);
  const [messageApi] = message.useMessage();
  const location = useLocation();

  const HandleSubmit = () => {
    const info = (msg: string) => {
      messageApi.success(msg, 1);
    };
    const error = (mes: string) => {
      messageApi.error(mes);
    };
    form.validateFields().then(async (val: IVendorCreatePasswordProps) => {
      setLoading(true);
      const password = MD5(val?.password).toString();
      const confirmPassword = MD5(val?.confirmPassword).toString();

      AuthService.CreatePassword(
        location.search.split("token=")[1],
        password,
        confirmPassword
      )
        .then((res: any) => {
          console.log("from createpassword page:", res);
          if (res?.status === true) {
            info("password created successfully");
            form.resetFields();
            navigate("/vendor/login");
          } else {
            error("Something went to wrong");
            form.resetFields();
          }
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          background:
            "radial-gradient(80.32% 80.32% at 50% 50%, #058BC9 0%, #0E3878 100%)",
        }}
      >
        <div style={{ maxWidth: "390px", margin: "0 auto", padding: "10px" }}>
          <Row
            gutter={15}
            justify={"center"}
            style={{ paddingBottom: "50px", marginRight: 0 }}
          >
            <Col>
              <img alt="capsi" src={layer} style={{ height: "40px" }} />
            </Col>
            <Col>
              <h1>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "white",
                  }}
                >
                  Capsi
                </span>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "400",
                    marginLeft: "9px",
                    color: "white",
                  }}
                >
                  Books
                </span>
              </h1>
            </Col>
          </Row>
          <Card size="small" type="inner" style={{ padding: "15px" }}>
            <p className="secondloginheading" style={{ color: "#4d4d4d" }}>
              Create Password
            </p>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "10px",
                fontWeight: "300",
              }}
            >
              Add password to complete your account creation.
            </p>

            <Form layout="horizontal" form={form} labelAlign="left">
              <Row>
                <Col span={24} className="loginnames">
                  Password
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter password!",
                      },
                    ]}
                    hasFeedback
                  >
                    <Input.Password placeholder="Enter new password" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} className="loginnames">
                  Confirm Password
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="confirmPassword"
                    dependencies={["password"]}
                    rules={[
                      {
                        required: true,
                        message: "Enter confirm password",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "The new password that you Entered do not match!"
                            )
                          );
                        },
                      }),
                    ]}
                    hasFeedback
                  >
                    <Input.Password placeholder="Enter confirm password" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item>
                <Row justify="center">
                  <Col lg={24}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="check"
                      onClick={() => HandleSubmit()}
                      style={{
                        backgroundColor: "#058BC9",
                        color: "white",
                        width: "100%",
                      }}
                    >
                      {loading ? (
                        <Spin indicator={antIcon} />
                      ) : (
                        "Create Password"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default VendorCreatePassword;
